// Indicatore SLA con contatore e stato
import { Clock, AlertTriangle } from 'lucide-react'
import { isSlaBreached, slaMinutesRemaining } from '@fieldcore/utils'
import { parseISO } from 'date-fns'
import { cn } from '../../../lib/utils'

interface SLAIndicatorProps {
  deadline: string
  className?: string
  showLabel?: boolean
}

export function SLAIndicator({ deadline, className, showLabel = true }: SLAIndicatorProps) {
  const deadlineDate = parseISO(deadline)
  const breached = isSlaBreached(deadlineDate)
  const minutesLeft = slaMinutesRemaining(deadlineDate)

  const formatTime = (minutes: number) => {
    const abs = Math.abs(minutes)
    if (abs < 60) return `${abs}m`
    const h = Math.floor(abs / 60)
    const m = abs % 60
    return `${h}h${m > 0 ? ` ${m}m` : ''}`
  }

  const isWarning = !breached && minutesLeft < 120 // meno di 2h

  return (
    <div
      className={cn(
        'flex items-center gap-1.5 text-xs font-medium',
        breached && 'text-[var(--fc-danger)]',
        isWarning && !breached && 'text-[var(--fc-warning)]',
        !breached && !isWarning && 'text-[var(--fc-foreground-muted)]',
        className
      )}
      aria-label={`SLA: ${breached ? 'scaduto' : isWarning ? 'in scadenza' : 'ok'}`}
    >
      {breached ? (
        <AlertTriangle className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
      ) : (
        <Clock className={cn('h-3.5 w-3.5 shrink-0', isWarning && 'animate-pulse')} aria-hidden="true" />
      )}
      {showLabel && (
        <span>
          {breached ? `Scaduto ${formatTime(minutesLeft)} fa` : `${formatTime(minutesLeft)} rimanenti`}
        </span>
      )}
    </div>
  )
}
